var render = function render(){var _vm=this,_c=_vm._self._c;return _c('surroundBox',{attrs:{"name":_vm.description,"unit":_vm.unit,"desc":"秸秆收纳重量"}},[_c('template',{slot:"content"},[_c('div',{staticClass:"straw-echart",staticStyle:{"width":"100%","height":"100%"}})])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }